// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1vE7j","icon":"Header_icon__C3HRz","title":"Header_title__pfe06","withIcon":"Header_withIcon__7W1BG"};